import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { IEmpresa, IRelatorios, ITags } from "../../../model";

export const RelatoriosSelect = Select.ofType<IRelatorios>();

export const filterRel: ItemPredicate<IRelatorios> = (query, tag) => {
  return tag.nome.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

export const renderRel: ItemRenderer<IRelatorios> = (
  tag,
  { handleClick, modifiers },
) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={tag.id}
      text={tag.nome}
      onClick={handleClick}
      label={(tag.modelo)}
    />
  );
};
